import * as types from '../actions/actionTypes';
import initialState from './initialState';

        
        
export default function referenciabancariaReducer(state= initialState.referenciabancaria, action){
    let newState;
	switch(action.type){
         case types.LOAD_REFERENCIABANCARIA_LIST_SUCCESS:		
            action.referenciabancaria.filtroActivo=state.filtroActivo;
            action.referenciabancaria.filtroActual=state.filtroActual;
            action.referenciabancaria.showActivos=state.showActivos;
			 action.referenciabancaria.paginaActual=action.referenciabancaria.pageable.pageNumber;
			 action.referenciabancaria.registrosPorPagina=action.referenciabancaria.size;
            
            return action.referenciabancaria;

        case types.BORRAR_REFERENCIABANCARIA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(referenciabancaria => referenciabancaria.id !== action.referenciabancaria.id)];          
			return newState;    
            
        case types.ACTIVAR_REFERENCIABANCARIA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(referenciabancaria => referenciabancaria.id !== action.referenciabancaria.id)];          
			 return newState;
            
        case types.SET_FILTRO_REFERENCIABANCARIA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}